import { type ReactElement } from 'react';

const Home = (): ReactElement => {
    

    return (
        <div>
            HOME
        </div>
    )
}

export default Home;